import { createStore, select, setProp, withProps } from "@ngneat/elf";
import { NominatimObject, SearchResultObject } from "../map/Feature";

export interface SearchStoreProps {
	data?: NominatimObject[] | SearchResultObject[];
	loading?: boolean;
	details?: string;
}

const searchStore = createStore({ name: "search" }, withProps<SearchStoreProps>({ loading: false }));

export function getSearchStore() {
	return searchStore.pipe(select((state) => state));
}

export function updateSearchStore(props: SearchStoreProps) {
	for (const key in props) {
		if (Object.prototype.hasOwnProperty.call(props, key)) {
			searchStore.update(setProp(key as keyof SearchStoreProps, (props as any)[key]));
		}
	}
}
